import { coreClient } from './coreclient'
import type { BillingAddress, Subscription } from 'common'

export default {
  async getCustomerPortal() {
    let return_url = window.location.href
    if (return_url.includes('/settings/billing')) {
      return_url = return_url.replace('/settings/billing', '/')
    }
    const client = await coreClient()
    return client.stripe
      .getCustomerPortal(return_url)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getChildSubscriptions() {
    const client = await coreClient()
    return client.stripe
      .getChildrenSubscriptions()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as Subscription[]
      })
  },
  async closeChildAccount(subscriptionId: string) {
    const client = await coreClient()
    return client.stripe
      .closeChildAccount(subscriptionId)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async keepChildAccount(subscriptionId: string) {
    const client = await coreClient()
    return client.stripe
      .keepChildAccount(subscriptionId)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getCustomerApiKeys() {
    const client = await coreClient()
    return client.stripe
      .getCustomerApiKeys()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async createPropertyReportsSubscription(card: string, coupon?: string, address?: BillingAddress) {
    const client = await coreClient()
    return client.stripe
      .createPropertyReportsSubscription({ payment_method_id: card, promo_code: coupon, address })
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async createMarketReportsSubscription() {
    const client = await coreClient()
    return client.stripe
      .createMarketReportsSubscription()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async propertyReportTrialConsumed() {
    const client = await coreClient()
    return client.stripe
      .propertyReportTrialConsumed()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async setPaymentMethod(card: string) {
    const client = await coreClient()
    return client.stripe
      .setPaymentMethod({ payment_method_id: card })
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getUpcomingInvoice() {
    const client = await coreClient()
    return client.stripe
      .getUpcomingInvoice()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async checkPromoCode(code: string) {
    const client = await coreClient()
    return client.stripe
      .checkPromoCodeController(code)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async updateNumberPropertyReportsSeats(seats: number) {
    const client = await coreClient()
    return client.stripe
      .updateNumberPropertyReportsSeats(seats)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getCustomerSubscriptions() {
    const client = await coreClient()
    return client.stripe
      .getCustomerSubscriptions()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as Subscription[]
      })
  },
  async cancelSubscription() {
    const client = await coreClient()
    return client.stripe
      .cancelSubscription()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async renewSubscription() {
    const client = await coreClient()
    return client.stripe
      .renewSubscription()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
